import axiosPost from '../axiosPost';

export const provinciasGet = async (arg) => {
    const body = {
        "service": "ProvinciaGet",
        "params": {}
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } catch (err) {
        console.log(err)
    }
};